export const onlyNumbersAndLettersRegex = /^[A-Za-z0-9]+$/;

export function onlyNumbersAndLetters(string) {
  if (!string) return true;

  return onlyNumbersAndLettersRegex.test(string);
}
